import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { memo } from 'react';
import styles from './queueFromPayload.module.scss';
const NO_QUEUE_SELECTED = 'No queue selected';
function QueueFromPayload({ className, extraData = {}, hasSettings, node: { payload }, }) {
    const { queue } = payload;
    const label = queue && queue.label;
    const queueID = queue && queue.value;
    const { queues = null } = extraData;
    let queueName = NO_QUEUE_SELECTED;
    if (queues !== null && queueID) {
        const match = queues.find((queue) => queue.id === queueID);
        if (match) {
            queueName = match.name;
        }
    }
    if (queueName === NO_QUEUE_SELECTED && label) {
        queueName = label;
    }
    // The order of the settingsLabel entries should be unchanged
    // since it reflects the order of settings in the Queue modal.
    //
    // announcement_attributes, queue_timeout, wait_music_v2, callbackInfo
    const settingsLabel = {
        announcement_attributes: 'announce queue position',
        queue_timeout: 'timeout',
        wait_music_v2: 'custom wait music',
        callbackInfo: 'callback',
    };
    const settings = Object.entries(settingsLabel).reduce((settings, [key, value]) => {
        const isAnnouncementAttributes = key === 'announcement_attributes';
        const data = payload[key];
        if (isAnnouncementAttributes ? data === null || data === void 0 ? void 0 : data.play_announcement : data) {
            settings.push(value);
        }
        return settings;
    }, []);
    const settingsText = settings.join(', ');
    return (_jsxs("div", Object.assign({ className: classnames(styles.root, className) }, { children: [_jsxs("div", Object.assign({ className: styles.queue }, { children: ["Queue ", _jsx("strong", { children: queueName })] })), hasSettings && (_jsxs("div", Object.assign({ className: styles.settings }, { children: ["Settings", ' ', _jsx("strong", { children: settings.length > 0
                            ? `${settingsText[0].toUpperCase()}${settingsText.slice(1)}`
                            : 'None' })] })))] })));
}
export default memo(QueueFromPayload);
